<aims-common-table
id="asset-config-locations"
[dataSource]="resources | async"
[header]="header"
[pageSize]="10"
[permissions]="tablePermissions| async"
[addRowInitialObject]="initialTableObject"
(rowUpdated)="handleRowUpdate($event)"
(rowAdded)="handleRowAdd($event)"
>

<aims-common-table-dynamic-row id="siteId">
  <ng-template viewMode let-element>{{ element.siteId | getText:'siteId':'siteName':sites }}</ng-template>
  <ng-template editMode let-element let-idx="idx" let-dynamicControl="dynamicControl">
    <mat-form-field appearance="fill" class="form-component">
      <mat-label>Site</mat-label>
      <mat-select [formControl]="dynamicControl">
        <mat-option *ngFor="let val of sites" [value]="val.siteId">
          {{val.siteName}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="dynamicControl.hasError('required')">You must make a selection</mat-error>
    </mat-form-field>
  </ng-template>
  <ng-template aimsFilterTemplate let-filterChange="filterChange" let-filter="filter">
    <mat-form-field appearance="fill" style="margin-top: 20px; width: 100%">
      <mat-label>Filter</mat-label>
      <mat-select (selectionChange)="filterChange($event.value)" [ngModel]="filter">
        <mat-option label=""></mat-option>
        <mat-option *ngFor="let val of sites" [value]="val.siteId">
          {{val.siteName}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </ng-template>
</aims-common-table-dynamic-row>

</aims-common-table>
